// extracted by mini-css-extract-plugin
export var externalLink = "_an-0";
export var internalLinkLabel = "_an-1";